<div class="modal-body">
  <table class="table table-bordered text custom-table">
    <thead style="text-align: center">
      <tr>
        <th>Account Code</th>
        <th>Account Description</th>
        <th>Counterparty</th>
        <th>prior year trail balance in USD (a)</th>
        <th>prior year GAAP in USD (b)</th>
        <th>prior year submission in USD (c = a + b)</th>
        <th>Adjustments for opening Balance sheet (d)</th>
        <th>Adjusted Balances - Begining of year (c * ExchangeRate) + d</th>
      </tr>
      <tr>
        <th>Assets</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (item of adjustData; track $index) {
<tr>
        <td>{{ item.num }}</td>
        <td>{{ item.des }}</td>
        <td></td>
        <td class="text-right">{{ item.prioi_year_trail }}</td>
        <td class="text-right">{{ item.prioi_year_GAAP }}</td>
        <td class="text-right">{{ item.prioi_year_submission }}</td>
        <td>
          <input type="text" [ngModel]="item.adjustment_open" (ngModelChange)="item.adjustment_open = $event; onAdjustmentChange()" class="form-control text-right" />
        </td>
        <td class="text-right">{{ item.adjusted_bal }}</td>
      </tr>
}
    </tbody>
  </table>
</div>
